// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"38a9f480","531":"639e01f0","839":"40583c7a"}[chunkId] + ".chunk.js";
};